import React from 'react'
import MySelectSearch from '../../../UI/form/MySelectSearch'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { useEffect } from 'react'
import { useState } from 'react'
import { getPositionsForWriteOffAPI } from '../../../../api/writeOff/writeOffActAPI'
import { useSelector } from 'react-redux'
// import { unitMeasureShortText } from '../../../../helpers/unitMeasure/UnitMeasureHelper'

const WriteOffActItemSearch = ({ departmentId, required, setValidate, setValueForm, forciblyValue, className, setPositionForWriteOff }) => {

	const unitMeasures = useSelector(state => state.settings.unitMeasures)

    const [value, setValue] = useState(forciblyValue)
    const [query, setQuery] = useState('')
    // console.log('query', query)
  	const [validSelect, setValidSelect] = useState(false)
	const [positions, setPositions] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
        if (query && query.length >= 3) {
            getPositionsForWriteOff()
        } else {
            setPositions([])
        }
	}, [query])

	useEffect(() => {
		valid()
	}, [required, value])

	const getPositionsForWriteOff = () => {
        setLoading(true)
        setPositions([])
		getPositionsForWriteOffAPI({ departmentId, query }).then(data => {
			// setPositions(data.positions)
			setPositions(data)
            setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
            setLoading(false)
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <div className={className}>
		<MySelectSearch
			// optionDefault={}
			// nameField={}
			setQuery={setQuery}
			label={'Позиція для списання'}
			placeholder={'Введіть для пошуку'}
			labelId={'select__writeOffActPosition-label'}
			id={'select__writeOffActPosition'}
			// value={value ? {id: value, name: positions[0].name} : ''}
			value={value}
			onChange = {e => {
				setValueForm(e)
				setValue(e)
				if (e) {
                    const found = positions.find(p => p.id === e)
                    if (found) {
                       	setPositionForWriteOff(found)
                    }
                }
			}}
			loading={loading}
			setLoading={setLoading}
			// disabled={}
			// loading={}
			options={
				positions && positions.length > 0 ? 
					positions.map(position => {
						// return {id: position.id, name: `${position.name} / ${position.nameInBill} / К-сть: ${position.countForWriteOff} ${unitMeasureShortText[position.unitMeasure]} / (ID рах. ${position.supplyBillId}, ID поз. ${position.supplyOrderItemId})`}
						return {id: position.id, name: `${position.name} / ${position.nameInBill} / К-сть: ${position.countForWriteOff} ${unitMeasures[position.unitMeasure] ? unitMeasures[position.unitMeasure].name : '?'} / (ID рах. ${position.supplyBillId}, ID поз. ${position.supplyOrderItemId})`}
					})
				: []	
			}
		/>
	</div>
  )
}

export default WriteOffActItemSearch